import { styled } from '@mui/system'

const StatusPanel = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.grey?.[200],
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center'
}))

export { StatusPanel }
